"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("../VirtualScrollListToSelect/index.vue"));
var _axios = _interopRequireDefault(require("@/utils/axios"));
var _pinyin = _interopRequireDefault(require("pinyin"));
var _default = exports.default = {
  name: 'BasisShopListToSelect',
  // 店铺列表选择组件
  components: {
    VirtualScrollListToSelect: _index.default
  },
  props: {
    ..._index.default.props,
    searchPlaceholder: {
      type: String,
      default: '请输入店铺名称或所属平台关键字进行搜索'
    },
    scrollHeight: {
      type: String,
      default: 'calc(70vh - 300px)'
    },
    // 替换 checkbox 中的 title，value，key
    replaceFields: {
      type: Object,
      default: () => {
        return {
          title: '_title',
          value: 'shopNo',
          key: 'shopNo'
        };
      }
    },
    // 是否支持多选，false 为单选
    multiple: {
      type: Boolean,
      default: true
    },
    // 用于搜索的字段
    searchFiled: {
      type: String,
      default: '_searchWords'
    },
    // 自定义属性 - 获取店铺列表数据接口
    getShopListApi: {
      type: String,
      default: '/v1/wdt/shop/list'
    },
    // 是否显示tooltip
    showToolTip: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      targetData: [] // 经过格式转换后的最终用于展示的数据
    };
  },
  watch: {
    // dataSource 数据。由于该组件为店铺列表结构展示使用的，故dataSource的数据结构必须按照标准店铺列表结构返回，否则无法进行转换解释
    dataSource: {
      handler(val, oldVal) {
        // 如果没有从外部传值进来，则使用接口获取店铺列表数据
        if (oldVal === undefined && val === undefined) {
          this.getShopList();
        } else {
          this.initListData(val);
          this.targetData = val;
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleChange(val, allCheckedList) {
      this.$emit('change', val, allCheckedList);
    },
    // 转换成拼音，用于支持通过拼音搜索
    transformToPinyin(words) {
      // 普通风格，即不带声调
      const res = (0, _pinyin.default)(words, {
        style: _pinyin.default.STYLE_NORMAL
      }).toString().replace(/,/g, '');
      // 首字母风格，只返回拼音的首字母部分
      const res2 = (0, _pinyin.default)(words, {
        style: _pinyin.default.STYLE_FIRST_LETTER
      }).toString().replace(/,/g, '');
      return `${res}${res2}`;
    },
    initListData(list) {
      list.map(item => {
        item._title = item.platformName ? `${item.shopName}（${item.platformName}）` : item.shopName;
        item._searchWords = item._title + this.transformToPinyin(item._title);
        return item;
      });
    },
    async getShopList() {
      try {
        const res = await _axios.default.get(this.getShopListApi);
        this.initListData(res);
        this.targetData = res;
      } catch (error) {}
    }
  }
};